var AR = require('component/core/core.js');

var buttonTitle = AR.locale({ru: 'Увеличить', en: 'Zoom in'});

$.fn.extend({
	/**
	 * Добавить кнопку увеличения
	 * @param {String} contentSelector Селектор элемента с контентом (напр. 'table')
	 * @param {String} containerClass Класс, который будет добавлен к контейнеру элемента
	 */
	addZoomIn: function (contentSelector, containerClass) {
		return this.each(function () {
			var $this = $(this);
			var element = $this[0];
			$this.find('.js-buttons')
				.append(`<button class="button button--zoom js-button-zoom" title="${buttonTitle}">${buttonTitle}</button>`)
				.find('.js-button-zoom')
				.on('click', function zoomIn(event) {
					event.preventDefault();

					var svgContent = $(element).has('[data-svg]').length ? element.innerHTML : undefined;
					// Убираем из содержимого контейнера служебный div с кнопками
					var html = element.outerHTML.replace(/<div[^\>\<]+class="[^\"]*js-buttons[^\"]*".*<\/button><\/div>/, '');

					if (svgContent) {
						$.colorbox({
							width: '95%',
							maxHeight: '95%',
							// height: '95%',
							transition: 'elastic',
							speed: 300,
							fadeOut: 300,
							scalePhotos: true,
							className: containerClass,
							html: html
						});
					} else {
						$.colorbox({
							maxWidth: '95%',
							maxHeight: '95%',
							transition: 'elastic',
							speed: 300,
							fadeOut: 300,
							scalePhotos: true,
							className: containerClass,
							html: html
						});
					}

					global.blurOnLeave(this);
				});
		});
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/zoom-in/zoom-in.js
 **/